module.exports = __webpack_public_path__ + "img/noImg.3a55955a.png";